/** @jsxImportSource @emotion/react */
import tw from "twin.macro";

import { css } from "@emotion/css";
import {
  useObservable,
  useObservableState,
  useSubscription,
} from "observable-hooks";
import * as R from "ramda";
import React, { FC, memo, useState } from "react";
import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Note } from "../state/data";
import { useNotes } from "../state/state/store";
import { DraggableNote } from "./drag/DraggableNote";

export const ReadOnlyNoteList: FC<{
  selector: (n: Note) => boolean;
}> = memo(({ selector }) => {
  // console.count("NoteList render " + id);
  const { notes } = useNotes();
  const noteIds = notes.filter(selector).map((n) => n.id);

  return (
    <div tw="py-2 px-1" className={css``}>
      {noteIds.map((nid) => (
        <div key={nid} style={{ padding: 5 }}>
          <DraggableNote id={nid} />
        </div>
      ))}
      {noteIds.length === 0 && (
        <div tw="flex">
          <span tw="m-auto text-gray-300">All clear</span>
        </div>
      )}
    </div>
  );
});
